import { render } from "./recu.vue?vue&type=template&id=26f668e2&scoped=true"
import script from "./recu.vue?vue&type=script&lang=js"
export * from "./recu.vue?vue&type=script&lang=js"

import "./recu.vue?vue&type=style&index=0&id=26f668e2&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f668e2"]])

export default __exports__